export default __webpack_public_path__ + "static/media/elephant_standup.7ebb9766.png";